import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiEvents, BackendResponse, HttpService, ToastrService, TranslateService } from 'vas-mobile-api';

@Injectable({
  providedIn: 'root'
})
export class DeliveryBarrierService implements CanActivate {

  constructor(
    private httpService: HttpService,
    private router: Router,
    private toastService: ToastrService,
    private apiEvents: ApiEvents,
    private translateService: TranslateService) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.apiEvents.ready().then(() => {

        this.httpService.get<BackendResponse<any>>({ pathId: 'getLiefersperrFlag', withErrorNotification: false }).subscribe((result) => {

          if (result.data.flag !== false) {
            const msg = this.translateService.translateFirstLetterUpperCase('MESSAGE:CUSTOMER_DELIVERY_BLOCKADE');
            this.toastService.error(msg);
            this.router.navigate(['dashboard']);
          }
          resolve(!result.data.flag);
        }, (e) => {
          const msg = this.translateService.translateFirstLetterUpperCase('MESSAGE:CUSTOMER_DELIVERY_BLOCKADE');
          this.toastService.error(msg);
          this.router.navigate(['dashboard']);
          resolve(false);
        });
      }).catch(() => {
        const msg = this.translateService.translateFirstLetterUpperCase('MESSAGE:CUSTOMER_DELIVERY_BLOCKADE');
        this.toastService.error(msg);
        this.router.navigate(['dashboard']);
        resolve(false);
      });
    });
  }
}
